<app-spinner *ngIf="loadingRoomTypes"></app-spinner>

<div *ngIf="roomTypes && meta.totalItems > 0">
  <form name="form" novalidate>
    <div [hidden]="showListActions">
      <div class="form-group">
        <div class="input-group">
          <span class="input-group-addon">
            <i class="fa fa-search" title="{{ 'NAME' | translate }}"></i>
          </span>
          <app-search-text-input
            [field]="'by_name'"
            [value]="filterCriteria.by_name"
            [pattern]="'text'"
            [placeHolder]="'NAME'"
            (searched)="onSearched($event)"
          >
          </app-search-text-input>
        </div>
      </div>
    </div>

    <!-- Use ngif -->
    <div [hidden]="!showListActions">
      <app-list-actions
        [showListActions]="showListActions"
        [totalItems]="meta.totalItems"
        [totalItemsSelected]="totalItemsSelected"
        [permissions]="permissions"
        (updatedItems)="onUpdatedItems($event)"
        (deletedItems)="onDeletedItems()"
      >
      </app-list-actions>
    </div>
  </form>

  <div *ngIf="meta.itemsFound > 0">
    <table class="table table-striped table-hover table-highlight-head table-vertical-align">
      <thead>
        <tr>
          <th style="width: 40px" class="align-center">
            <label class="control control-checkbox">
              <input
                type="checkbox"
                [checked]="masterCheckboxSelected"
                (change)="utilService.checkUncheckAllItems(roomTypes, $event)"
              />
              <div class="control-indicator"></div>
            </label>
          </th>
          <th>
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'name'"
              (sorted)="onSorted($event)"
              >{{ 'NAME' | translate }}</app-sort-by
            >
          </th>
          <th>
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'description'"
              (sorted)="onSorted($event)"
              >{{ 'DESCRIPTION' | translate }}</app-sort-by
            >
          </th>
          <!-- style="width: 250px" -->
          <th style="width: 60px" class="align-center">
            <a
              (click)="reloadRoomTypes()"
              title="{{ 'REFRESH' | translate }}"
              class="btn btn-xs btn-transparent"
            >
              <i class="fa fa-refresh"></i>
            </a>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let roomType of roomTypes" id="{{ roomType.id }}">
          <td class="align-center">
            <label class="control control-checkbox">
              <input
                type="checkbox"
                [checked]="roomType.isSelected"
                (change)="utilService.checkUncheckItem(roomTypes, roomType, $event)"
              />
              <div class="control-indicator"></div>
            </label>
          </td>
          <!-- Name -->
          <td
            (click)="selectRoomType(roomType)"
            [ngClass]="utilService.checkItemStatus(roomType.status)"
            class="cursor"
          >
            {{ roomType.name }}
          </td>
          <!-- Description -->
          <td
            (click)="selectRoomType(roomType)"
            [ngClass]="utilService.checkItemStatus(roomType.status)"
            class="cursor"
          >
            {{ roomType.description }}
          </td>
          <td class="align-center">
            <div class="btn-group">
              <span class="dropdown-toggle btn btn-xs btn-transparent" data-toggle="dropdown">
                <i class="fa fa-ellipsis-h fa-lg"></i>
              </span>
              <ul class="dropdown-menu pull-right">
                <li *ngIf="permissions.canShow">
                  <a class="cursor" (click)="selectRoomType(roomType, 'edit')">
                    <i class="fa fa-pencil"></i> {{ 'EDIT' | translate }}
                  </a>
                </li>
                <li *ngIf="permissions.canUpdate">
                  <a class="cursor" (click)="changeRoomTypeStatus(roomType)">
                    <i
                      [ngClass]="
                        roomType.status === 'active' ? 'fa fa-minus-square' : 'fa fa-check-square'
                      "
                    ></i>
                    {{
                      roomType.status === 'active'
                        ? ('DEACTIVATE' | translate)
                        : ('ACTIVATE' | translate)
                    }}
                  </a>
                </li>
                <li class="divider"></li>
                <li *ngIf="permissions.canDestroy">
                  <a class="cursor" (click)="deleteRoomType(roomType)">
                    <i class="fa fa-trash"></i> {{ 'DELETE' | translate }}</a
                  >
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <app-table-footer
      [meta]="meta"
      (selectedPage)="onSelectedPage($event)"
      *ngIf="meta.totalPages > 1"
    ></app-table-footer>
  </div>

  <div *ngIf="meta.itemsFound === 0" class="alert alert-warning align-center" style="padding: 40px">
    <i class="fa fa-ban fa-4x"></i>
    <h3>{{ 'NO_ITEMS_FOUND' | translate }}</h3>

    <a (click)="reloadRoomTypes()" class="cursor">
      <i class="fa fa-times"></i> {{ 'CLEAR_SEARCH' | translate }}
    </a>
  </div>
</div>

<div
  *ngIf="roomTypes && meta.totalItems === 0"
  class="alert alert-info align-center"
  style="padding: 40px"
>
  <i class="fa fa-ban fa-4x"></i>
  <h5>{{ 'NO_ITEMS_FOUND' | translate }}</h5>
</div>
